import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=300b5ae2&scoped=true"
import script from "./Threads.vue?vue&type=script&lang=ts"
export * from "./Threads.vue?vue&type=script&lang=ts"
import style0 from "./Threads.vue?vue&type=style&index=0&id=300b5ae2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300b5ae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('300b5ae2')) {
      api.createRecord('300b5ae2', component.options)
    } else {
      api.reload('300b5ae2', component.options)
    }
    module.hot.accept("./Threads.vue?vue&type=template&id=300b5ae2&scoped=true", function () {
      api.rerender('300b5ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/Threads.vue"
export default component.exports